import { UniDriver } from '@wix/unidriver-core';
import { baseModalLayoutDriverFactory } from '../BaseModalLayout/BaseModalLayout.uni.driver';

export type MessageModalLayoutUniDriver = ReturnType<
  typeof messageModalLayoutDriverFactory
>;

export const messageModalLayoutDriverFactory = (base: UniDriver) => {
  return {
    ...baseModalLayoutDriverFactory(base),
  };
};
